import { Provider } from "components/processing-status/ProcessingStatusContext";
import { ProcessingStatusList } from "components/processing-status/ProcessingStatusList";

export const ProcessingStatuses = () => {
    return (
        <Provider>
            <ProcessingStatusList />
        </Provider>
    );
};
